import { render, staticRenderFns } from "./OutCodeBackBtn.vue?vue&type=template&id=fd99071a&scoped=true&"
import script from "./OutCodeBackBtn.vue?vue&type=script&lang=js&"
export * from "./OutCodeBackBtn.vue?vue&type=script&lang=js&"
import style0 from "./OutCodeBackBtn.vue?vue&type=style&index=0&id=fd99071a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd99071a",
  null
  
)

export default component.exports